import { connectCustom } from "@client/lib/misc";

import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import OKModal, { type OKModalActionProps, type OKModalMapProps } from "@client/controls/Modal/Modals/OK/component";
import { TargetSelector, combinedSettingsSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import classnames from "classnames";
import { setModalVisible } from "../actions";
import { localStateSelector } from "../selectors";

const makeMapStateToProps = () => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, ["title", "content"], "modal");

  return (state: AppState, props: RootContainerProps): OKModalMapProps => {
    const localState = localStateSelector(state, props);
    const settings = settingsSelector(state, props);

    return {
      ...props,
      className: classnames({ success: !localState.submitError, error: !!localState.submitError }),
      submitError: localState.submitError,
      title: settings.title,
      children: localState.submitError ? localState.submitError : settings.content,
      isVisible: localState.showModal
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): OKModalActionProps => ({
  onClose: () => dispatch(setModalVisible(getEntityRef(props), false))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(OKModal);
